'use strict'

import axios from 'axios'

const { VUE_APP_COMMS_URL } = process.env

export default async ({ type, jwt, limit, cursor, filter }) => axios({
  method: 'get',
  headers: {
    Authorization: jwt,
    ...limit && { limit },
    ...cursor && { cursor }
  },
  params: {
    ...filter && { filter }
  },
  url: `${VUE_APP_COMMS_URL}/${type}`,
  timeout: 8000
})
